export const pays = [
  {
    "code": "AF",
    "nom": "Afghanistan"
  },
  {
    "code": "ZA",
    "nom": "Afrique du Sud"
  },
  {
    "code": "AL",
    "nom": "Albanie"
  },
  {
    "code": "DZ",
    "nom": "Algérie"
  },
  {
    "code": "DE",
    "nom": "Allemagne"
  },
  {
    "code": "AD",
    "nom": "Andorre"
  },
  {
    "code": "AO",
    "nom": "Angola"
  },
  {
    "code": "AI",
    "nom": "Anguilla"
  },
  {
    "code": "AQ",
    "nom": "Antarctique"
  },
  {
    "code": "AG",
    "nom": "Antigua-et-Barbuda"
  },
  {
    "code": "SA",
    "nom": "Arabie saoudite"
  },
  {
    "code": "AR",
    "nom": "Argentine"
  },
  {
    "code": "AM",
    "nom": "Arménie"
  },
  {
    "code": "AW",
    "nom": "Aruba"
  },
  {
    "code": "AU",
    "nom": "Australie"
  },
  {
    "code": "AT",
    "nom": "Autriche"
  },
  {
    "code": "AZ",
    "nom": "Azerbaïdjan"
  },
  {
    "code": "BS",
    "nom": "Bahamas"
  },
  {
    "code": "BH",
    "nom": "Bahreïn"
  },
  {
    "code": "BD",
    "nom": "Bangladesh"
  },
  {
    "code": "BB",
    "nom": "Barbade"
  },
  {
    "code": "BE",
    "nom": "Belgique"
  },
  {
    "code": "BZ",
    "nom": "Belize"
  },
  {
    "code": "BM",
    "nom": "Bermudes"
  },
  {
    "code": "BT",
    "nom": "Bhoutan"
  },
  {
    "code": "BY",
    "nom": "Biélorussie"
  },
  {
    "code": "BO",
    "nom": "Bolivie"
  },
  {
    "code": "BA",
    "nom": "Bosnie-Herzégovine"
  },
  {
    "code": "BW",
    "nom": "Botswana"
  },
  {
    "code": "BN",
    "nom": "Brunei"
  },
  {
    "code": "BR",
    "nom": "Brésil"
  },
  {
    "code": "BG",
    "nom": "Bulgarie"
  },
  {
    "code": "BF",
    "nom": "Burkina Faso"
  },
  {
    "code": "BI",
    "nom": "Burundi"
  },
  {
    "code": "BJ",
    "nom": "Bénin"
  },
  {
    "code": "KH",
    "nom": "Cambodge"
  },
  {
    "code": "CM",
    "nom": "Cameroun"
  },
  {
    "code": "CA",
    "nom": "Canada"
  },
  {
    "code": "CV",
    "nom": "Cap-Vert"
  },
  {
    "code": "CL",
    "nom": "Chili"
  },
  {
    "code": "CN",
    "nom": "Chine"
  },
  {
    "code": "CY",
    "nom": "Chypre"
  },
  {
    "code": "CO",
    "nom": "Colombie"
  },
  {
    "code": "KM",
    "nom": "Comores"
  },
  {
    "code": "CG",
    "nom": "Congo-Brazzaville"
  },
  {
    "code": "CD",
    "nom": "Congo-Kinshasa"
  },
  {
    "code": "KP",
    "nom": "Corée du Nord"
  },
  {
    "code": "KR",
    "nom": "Corée du Sud"
  },
  {
    "code": "CR",
    "nom": "Costa Rica"
  },
  {
    "code": "HR",
    "nom": "Croatie"
  },
  {
    "code": "CU",
    "nom": "Cuba"
  },
  {
    "code": "CW",
    "nom": "Curaçao"
  },
  {
    "code": "CI",
    "nom": "Côte d’Ivoire"
  },
  {
    "code": "DK",
    "nom": "Danemark"
  },
  {
    "code": "DJ",
    "nom": "Djibouti"
  },
  {
    "code": "DM",
    "nom": "Dominique"
  },
  {
    "code": "ES",
    "nom": "Espagne"
  },
  {
    "code": "EE",
    "nom": "Estonie"
  },
  {
    "code": "SZ",
    "nom": "Eswatini"
  },
  {
    "code": "FJ",
    "nom": "Fidji"
  },
  {
    "code": "FI",
    "nom": "Finlande"
  },
  {
    "code": "FR",
    "nom": "France"
  },
  {
    "code": "GA",
    "nom": "Gabon"
  },
  {
    "code": "GM",
    "nom": "Gambie"
  },
  {
    "code": "GH",
    "nom": "Ghana"
  },
  {
    "code": "GI",
    "nom": "Gibraltar"
  },
  {
    "code": "GD",
    "nom": "Grenade"
  },
  {
    "code": "GL",
    "nom": "Groenland"
  },
  {
    "code": "GR",
    "nom": "Grèce"
  },
  {
    "code": "GP",
    "nom": "Guadeloupe"
  },
  {
    "code": "GU",
    "nom": "Guam"
  },
  {
    "code": "GT",
    "nom": "Guatemala"
  },
  {
    "code": "GG",
    "nom": "Guernesey"
  },
  {
    "code": "GN",
    "nom": "Guinée"
  },
  {
    "code": "GQ",
    "nom": "Guinée équatoriale"
  },
  {
    "code": "GW",
    "nom": "Guinée-Bissau"
  },
  {
    "code": "GY",
    "nom": "Guyana"
  },
  {
    "code": "GF",
    "nom": "Guyane française"
  },
  {
    "code": "GE",
    "nom": "Géorgie"
  },
  {
    "code": "GS",
    "nom": "Géorgie du Sud-et-les Îles Sandwich du Sud"
  },
  {
    "code": "HT",
    "nom": "Haïti"
  },
  {
    "code": "HN",
    "nom": "Honduras"
  },
  {
    "code": "HU",
    "nom": "Hongrie"
  },
  {
    "code": "IN",
    "nom": "Inde"
  },
  {
    "code": "ID",
    "nom": "Indonésie"
  },
  {
    "code": "IQ",
    "nom": "Irak"
  },
  {
    "code": "IR",
    "nom": "Iran"
  },
  {
    "code": "IE",
    "nom": "Irlande"
  },
  {
    "code": "IS",
    "nom": "Islande"
  },
  {
    "code": "IL",
    "nom": "Israël"
  },
  {
    "code": "IT",
    "nom": "Italie"
  },
  {
    "code": "JM",
    "nom": "Jamaïque"
  },
  {
    "code": "JP",
    "nom": "Japon"
  },
  {
    "code": "JE",
    "nom": "Jersey"
  },
  {
    "code": "JO",
    "nom": "Jordanie"
  },
  {
    "code": "KZ",
    "nom": "Kazakhstan"
  },
  {
    "code": "KE",
    "nom": "Kenya"
  },
  {
    "code": "KG",
    "nom": "Kirghizstan"
  },
  {
    "code": "KI",
    "nom": "Kiribati"
  },
  {
    "code": "KW",
    "nom": "Koweït"
  },
  {
    "code": "RE",
    "nom": "La Réunion"
  },
  {
    "code": "LA",
    "nom": "Laos"
  },
  {
    "code": "LS",
    "nom": "Lesotho"
  },
  {
    "code": "LV",
    "nom": "Lettonie"
  },
  {
    "code": "LB",
    "nom": "Liban"
  },
  {
    "code": "LR",
    "nom": "Liberia"
  },
  {
    "code": "LY",
    "nom": "Libye"
  },
  {
    "code": "LI",
    "nom": "Liechtenstein"
  },
  {
    "code": "LT",
    "nom": "Lituanie"
  },
  {
    "code": "LU",
    "nom": "Luxembourg"
  },
  {
    "code": "MK",
    "nom": "Macédoine du Nord"
  },
  {
    "code": "MG",
    "nom": "Madagascar"
  },
  {
    "code": "MY",
    "nom": "Malaisie"
  },
  {
    "code": "MW",
    "nom": "Malawi"
  },
  {
    "code": "MV",
    "nom": "Maldives"
  },
  {
    "code": "ML",
    "nom": "Mali"
  },
  {
    "code": "MT",
    "nom": "Malte"
  },
  {
    "code": "MA",
    "nom": "Maroc"
  },
  {
    "code": "MQ",
    "nom": "Martinique"
  },
  {
    "code": "MU",
    "nom": "Maurice"
  },
  {
    "code": "MR",
    "nom": "Mauritanie"
  },
  {
    "code": "YT",
    "nom": "Mayotte"
  },
  {
    "code": "MX",
    "nom": "Mexique"
  },
  {
    "code": "FM",
    "nom": "Micronésie"
  },
  {
    "code": "MD",
    "nom": "Moldavie"
  },
  {
    "code": "MC",
    "nom": "Monaco"
  },
  {
    "code": "MN",
    "nom": "Mongolie"
  },
  {
    "code": "MS",
    "nom": "Montserrat"
  },
  {
    "code": "ME",
    "nom": "Monténégro"
  },
  {
    "code": "MZ",
    "nom": "Mozambique"
  },
  {
    "code": "MM",
    "nom": "Myanmar (Birmanie)"
  },
  {
    "code": "NA",
    "nom": "Namibie"
  },
  {
    "code": "NR",
    "nom": "Nauru"
  },
  {
    "code": "NI",
    "nom": "Nicaragua"
  },
  {
    "code": "NE",
    "nom": "Niger"
  },
  {
    "code": "NG",
    "nom": "Nigeria"
  },
  {
    "code": "NU",
    "nom": "Niue"
  },
  {
    "code": "NO",
    "nom": "Norvège"
  },
  {
    "code": "NC",
    "nom": "Nouvelle-Calédonie"
  },
  {
    "code": "NZ",
    "nom": "Nouvelle-Zélande"
  },
  {
    "code": "NP",
    "nom": "Népal"
  },
  {
    "code": "OM",
    "nom": "Oman"
  },
  {
    "code": "UG",
    "nom": "Ouganda"
  },
  {
    "code": "UZ",
    "nom": "Ouzbékistan"
  },
  {
    "code": "PK",
    "nom": "Pakistan"
  },
  {
    "code": "PW",
    "nom": "Palaos"
  },
  {
    "code": "PA",
    "nom": "Panama"
  },
  {
    "code": "PG",
    "nom": "Papouasie-Nouvelle-Guinée"
  },
  {
    "code": "PY",
    "nom": "Paraguay"
  },
  {
    "code": "NL",
    "nom": "Pays-Bas"
  },
  {
    "code": "BQ",
    "nom": "Pays-Bas caribéens"
  },
  {
    "code": "PH",
    "nom": "Philippines"
  },
  {
    "code": "PL",
    "nom": "Pologne"
  },
  {
    "code": "PF",
    "nom": "Polynésie française"
  },
  {
    "code": "PR",
    "nom": "Porto Rico"
  },
  {
    "code": "PT",
    "nom": "Portugal"
  },
  {
    "code": "PE",
    "nom": "Pérou"
  },
  {
    "code": "QA",
    "nom": "Qatar"
  },
  {
    "code": "HK",
    "nom": "R.A.S. chinoise de Hong Kong"
  },
  {
    "code": "MO",
    "nom": "R.A.S. chinoise de Macao"
  },
  {
    "code": "RO",
    "nom": "Roumanie"
  },
  {
    "code": "GB",
    "nom": "Royaume-Uni"
  },
  {
    "code": "RU",
    "nom": "Russie"
  },
  {
    "code": "RW",
    "nom": "Rwanda"
  },
  {
    "code": "CF",
    "nom": "République centrafricaine"
  },
  {
    "code": "DO",
    "nom": "République dominicaine"
  },
  {
    "code": "EH",
    "nom": "Sahara occidental"
  },
  {
    "code": "BL",
    "nom": "Saint-Barthélemy"
  },
  {
    "code": "KN",
    "nom": "Saint-Christophe-et-Niévès"
  },
  {
    "code": "SM",
    "nom": "Saint-Marin"
  },
  {
    "code": "MF",
    "nom": "Saint-Martin"
  },
  {
    "code": "SX",
    "nom": "Saint-Martin (partie néerlandaise)"
  },
  {
    "code": "PM",
    "nom": "Saint-Pierre-et-Miquelon"
  },
  {
    "code": "VC",
    "nom": "Saint-Vincent-et-les Grenadines"
  },
  {
    "code": "SH",
    "nom": "Sainte-Hélène"
  },
  {
    "code": "LC",
    "nom": "Sainte-Lucie"
  },
  {
    "code": "SV",
    "nom": "Salvador"
  },
  {
    "code": "WS",
    "nom": "Samoa"
  },
  {
    "code": "AS",
    "nom": "Samoa américaines"
  },
  {
    "code": "ST",
    "nom": "Sao Tomé-et-Principe"
  },
  {
    "code": "RS",
    "nom": "Serbie"
  },
  {
    "code": "SC",
    "nom": "Seychelles"
  },
  {
    "code": "SL",
    "nom": "Sierra Leone"
  },
  {
    "code": "SG",
    "nom": "Singapour"
  },
  {
    "code": "SK",
    "nom": "Slovaquie"
  },
  {
    "code": "SI",
    "nom": "Slovénie"
  },
  {
    "code": "SO",
    "nom": "Somalie"
  },
  {
    "code": "SD",
    "nom": "Soudan"
  },
  {
    "code": "SS",
    "nom": "Soudan du Sud"
  },
  {
    "code": "LK",
    "nom": "Sri Lanka"
  },
  {
    "code": "CH",
    "nom": "Suisse"
  },
  {
    "code": "SR",
    "nom": "Suriname"
  },
  {
    "code": "SE",
    "nom": "Suède"
  },
  {
    "code": "SJ",
    "nom": "Svalbard et Jan Mayen"
  },
  {
    "code": "SY",
    "nom": "Syrie"
  },
  {
    "code": "SN",
    "nom": "Sénégal"
  },
  {
    "code": "TJ",
    "nom": "Tadjikistan"
  },
  {
    "code": "TZ",
    "nom": "Tanzanie"
  },
  {
    "code": "TW",
    "nom": "Taïwan"
  },
  {
    "code": "TD",
    "nom": "Tchad"
  },
  {
    "code": "CZ",
    "nom": "Tchéquie"
  },
  {
    "code": "TF",
    "nom": "Terres australes françaises"
  },
  {
    "code": "IO",
    "nom": "Territoire britannique de l’océan Indien"
  },
  {
    "code": "PS",
    "nom": "Territoires palestiniens"
  },
  {
    "code": "TH",
    "nom": "Thaïlande"
  },
  {
    "code": "TL",
    "nom": "Timor oriental"
  },
  {
    "code": "TG",
    "nom": "Togo"
  },
  {
    "code": "TK",
    "nom": "Tokelau"
  },
  {
    "code": "TO",
    "nom": "Tonga"
  },
  {
    "code": "TT",
    "nom": "Trinité-et-Tobago"
  },
  {
    "code": "TN",
    "nom": "Tunisie"
  },
  {
    "code": "TM",
    "nom": "Turkménistan"
  },
  {
    "code": "TR",
    "nom": "Turquie"
  },
  {
    "code": "TV",
    "nom": "Tuvalu"
  },
  {
    "code": "UA",
    "nom": "Ukraine"
  },
  {
    "code": "UY",
    "nom": "Uruguay"
  },
  {
    "code": "VU",
    "nom": "Vanuatu"
  },
  {
    "code": "VE",
    "nom": "Venezuela"
  },
  {
    "code": "VN",
    "nom": "Viêt Nam"
  },
  {
    "code": "WF",
    "nom": "Wallis-et-Futuna"
  },
  {
    "code": "YE",
    "nom": "Yémen"
  },
  {
    "code": "ZM",
    "nom": "Zambie"
  },
  {
    "code": "ZW",
    "nom": "Zimbabwe"
  },
  {
    "code": "EG",
    "nom": "Égypte"
  },
  {
    "code": "AE",
    "nom": "Émirats arabes unis"
  },
  {
    "code": "EC",
    "nom": "Équateur"
  },
  {
    "code": "ER",
    "nom": "Érythrée"
  },
  {
    "code": "VA",
    "nom": "État de la Cité du Vatican"
  },
  {
    "code": "US",
    "nom": "États-Unis"
  },
  {
    "code": "ET",
    "nom": "Éthiopie"
  },
  {
    "code": "BV",
    "nom": "Île Bouvet"
  },
  {
    "code": "CX",
    "nom": "Île Christmas"
  },
  {
    "code": "NF",
    "nom": "Île Norfolk"
  },
  {
    "code": "IM",
    "nom": "Île de Man"
  },
  {
    "code": "KY",
    "nom": "Îles Caïmans"
  },
  {
    "code": "CC",
    "nom": "Îles Cocos"
  },
  {
    "code": "CK",
    "nom": "Îles Cook"
  },
  {
    "code": "FO",
    "nom": "Îles Féroé"
  },
  {
    "code": "HM",
    "nom": "Îles Heard-et-MacDonald"
  },
  {
    "code": "FK",
    "nom": "Îles Malouines"
  },
  {
    "code": "MP",
    "nom": "Îles Mariannes du Nord"
  },
  {
    "code": "MH",
    "nom": "Îles Marshall"
  },
  {
    "code": "PN",
    "nom": "Îles Pitcairn"
  },
  {
    "code": "SB",
    "nom": "Îles Salomon"
  },
  {
    "code": "TC",
    "nom": "Îles Turques-et-Caïques"
  },
  {
    "code": "VG",
    "nom": "Îles Vierges britanniques"
  },
  {
    "code": "VI",
    "nom": "Îles Vierges des États-Unis"
  },
  {
    "code": "UM",
    "nom": "Îles mineures éloignées des États-Unis"
  },
  {
    "code": "AX",
    "nom": "Îles Åland"
  }
];